interface ResolveInheritedReportTemplateParams<T> {
    entity: T | null;
    workspace: T | null;
    firmDefault: T;
}

interface ResolvedInheritedReportTemplate<T> {
    value: T;
    level: "entity" | "workspace" | "firmDefault";
}

export const resolveInheritedReportTemplate = <T>({
    entity,
    workspace,
    firmDefault,
}: ResolveInheritedReportTemplateParams<T>): ResolvedInheritedReportTemplate<T> => {
    if (entity !== null) {
        return { value: entity, level: "entity" };
    }
    if (workspace !== null) {
        return { value: workspace, level: "workspace" };
    }
    return { value: firmDefault, level: "firmDefault" };
};
